interface ProjectItemProps {
  name: string;
  url: string;
  description: string;
}

export function ProjectItem({ name, url, description }: ProjectItemProps) {
  return (
    <div className="flex flex-col gap-2">
      <h4 className="font-medium">
        <a href={url} className="" target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      </h4>
      <p>{description}</p>
    </div>
  );
}
